/* global _paq */

import React, { PureComponent } from 'react';
import { numberFormat } from '../../helper/utils';

import { setBudget } from '../../modules/App/AppState';

import arrow from '../../public/images/arrow.svg';

import './incomeInput.styl';

function onFocusInput(inputType) {
  return () => {
    _paq.push(['trackEvent', 'input_focus', inputType, 'Schichtwechsel in Europa']);
  };
}

class IncomeInput extends PureComponent {
  constructor() {
    super();

    this.state = {
      resultVisible: false,
      nettoIncome: '',
      persOver14: '',
      persUnder14: '',
      inputError: false
    };
  }

  componentDidUpdate() {
    this.props.dispatch(setBudget(this.calculateResult()));
  }

  onInputChange = (event) => {
    const { name, value } = event.target;

    const hasError = !this.validateInput(value);
    if (hasError) {
      event.target.classList.add('income-input__error');
    } else {
      event.target.classList.remove('income-input__error');
    }

    this.setState({
      [name]: !hasError ? value : '',
      resultVisible: !hasError && value,
      inputError: hasError
    });
  }

  calculateResult() {
    return ((+this.state.nettoIncome / this.calcPersonFactor()) / this.props.formulaFactor) || '';
  }

  validateInput = val => (typeof +val === 'number') && (val >= 0);

  calcPersonFactor() {
    const persOver14Factor = this.state.persOver14 <= 1 ?
      1 : 1 + ((+this.state.persOver14 - 1) * 0.5);

    const persUnder14Factor = +this.state.persUnder14 * 0.3;

    return persOver14Factor + persUnder14Factor;
  }

  render() {
    if (!this.props.showIncomeSection) {
      return null;
    }

    return (
      <div className="income-input">
        <div className="income-input__wrapper">
          <div className="income-input__innerwrapper">
            <label className="income-input__label" htmlFor="netto-income">{this.props.translate('incomeInput.income')}</label>
            <input className="income-input__input" name="nettoIncome" type="text" onChange={this.onInputChange} onFocus={onFocusInput('nettoeinkommen')} />
          </div>

          <div className="income-input__innerwrapper">
            <label className="income-input__label" htmlFor="netto-income">{this.props.translate('incomeInput.personsOver14')}</label>
            <input className="income-input__input" name="persOver14" type="text" onChange={this.onInputChange} onFocus={onFocusInput('personen_ueber_14')} />
          </div>

          <div className="income-input__innerwrapper">
            <label className="income-input__label" htmlFor="netto-income">{this.props.translate('incomeInput.personsUnder14')}</label>
            <input className="income-input__input" name="persUnder14" type="text" onChange={this.onInputChange} onFocus={onFocusInput('personen_unter_14')} />
          </div>
          {this.state.resultVisible &&
            <div className="income-input__innerwrapper result__wrapper">
              <label className="income-input__label" htmlFor="netto-income"><span className="income-input__icon"><img src={arrow} alt="result arrow" /></span>{this.props.translate('incomeInput.result')}</label>
              <div className="income-input__result">{numberFormat(this.calculateResult(), this.props.currentLanguage)} Euro</div>
            </div>
          }

          {this.state.inputError && <div className="income-input__error">{this.props.translate('incomeInput.error')}</div>}
        </div>
      </div>
    );
  }
}

export default IncomeInput;



// WEBPACK FOOTER //
// ./src/components/IncomeInput/index.js